module.exports = __webpack_public_path__ + "static/media/cup.0f1cdec5.svg";